export default "__VITE_ASSET__C3aq9YB3__"